module.exports = __webpack_public_path__ + "img/success-dark.f3af11dc.svg";